import { render, staticRenderFns } from "./CompetencyMatrix.vue?vue&type=template&id=7f7d4ddc&scoped=true"
import script from "./CompetencyMatrix.vue?vue&type=script&lang=ts"
export * from "./CompetencyMatrix.vue?vue&type=script&lang=ts"
import style0 from "./CompetencyMatrix.vue?vue&type=style&index=0&id=7f7d4ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d4ddc",
  null
  
)

export default component.exports